import cn from "classnames";
import BookShow from "components/shared/book/show";
import { Transition } from "components/shared/column";
import { GeoPicker } from "components/shared/form";
import Loader from "components/shared/loader";
import { getInitialStateFromConfig, serializeReq } from "helpers/form";
import { requiredField } from "helpers/validators";
import React from "react";
import { customConnect } from "./container";

const config = {
    name: {
        label: "Название",
        inputProps: { name: "name" },
        validators: [requiredField],
        required: true,
    },
    comment: {
        label: "Комментарий",
        inputProps: { name: "comment" },
    },
    geozone: {
        validators: [requiredField],
    },
};

const initialState = getInitialStateFromConfig(config);

class RouteControlPoints extends BookShow {
    getItem = ({ source, match }) => {
        const defParams = { isLoading: false, isValid: true, shouldUpdate: false };
        if (match.params.id) {
            source.getItem(match.params).then((data) => this.setState({ data, initial: data, ...defParams }));
        } else {
            this.setState(defParams);
        }
    };

    get dropdActions() {
        const actions = [];
        if (!this.props.canEditBooks) {
            return actions;
        }
        actions.push({ text: "Удалить", action: this.actionClose });

        return actions;
    }

    apply = () => {
        const { source, match, mergeParams, back } = this.props;
        const { isLoading, shouldUpdate, ...state } = this.state;
        if (!isLoading && shouldUpdate) {
            if (this.isValidForm(state.data)) {
                this.setState({ isLoading: true, isValid: true });
                return source.apply(serializeReq({ ...match.params, ...state.data })).then((res) => {
                    if (res) {
                        match.params.id ? this.update(mergeParams) : back();
                    } else {
                        this.setState({ isLoading: false, isValid: false });
                    }
                });
            }
            this.setState({ isValid: false });
        }
    };

    renderButton = () => {
        if (!this.props.canEditBooks) {
            return null;
        }
        const cname = cn("btn btn-brand btn-sm", { disabled: !this.state.shouldUpdate });
        return (
            <div className="panel__row panel__row--button">
                <div className={cname} onClick={this.apply}>
                    {this.props.match.params.id ? "Обновить" : "Сохранить"}
                </div>
            </div>
        );
    };

    renderBody = () => {
        const { config, switchMap } = this.props;
        if (this.state.isLoading) {
            return <Loader prefix="absolute-center" />;
        }
        return (
            <>
                {this.renderField(config.name)}
                <GeoPicker
                    label="Адрес"
                    name="geozone"
                    switchMap={switchMap}
                    onChange={this.setValue}
                    value={this.state.data.geozone}
                    validators={[requiredField]}
                />
                {this.renderField(config.comment)}
                {this.renderButton()}
            </>
        );
    };

    render() {
        const cname = cn("book-show__body", { "book-show__body--invalid": !this.state.isValid });
        return (
            <Transition dir="full">
                <div className="page-book__show book-show">
                    {this.renderHead()}
                    <div className={cname}>{this.renderBodyWrap()}</div>
                </div>
            </Transition>
        );
    }
}

const ConfiguredShow = (props) => <RouteControlPoints {...props} config={config} initialState={initialState} />;

export default customConnect(ConfiguredShow);
